import {BulkImportLine} from "./bulk-ouvrage.model";

export interface CsvParseError {
  line: number;
  message: string;
  raw: string;
}

export interface CsvParseResult {
  lines: BulkImportLine[];
  errors: CsvParseError[];
}

const EAN_FORMAT = /^\d{13}$/;
const CODE_PROJET_FORMAT = /^[A-Za-z0-9-]+$/;

/**
 * Parse le CSV "EAN;CodeProjet" (2 colonnes, pas d'en-tête) importé en phase 1.
 * Les lignes mal formées ne sont pas envoyées au back : elles sont renvoyées comme erreurs
 * et affichées bloquées dans le récap de la phase 2, au même titre que les erreurs métier.
 */
export function parseBulkImportCsv(content: string): CsvParseResult {
  const lines: BulkImportLine[] = [];
  const errors: CsvParseError[] = [];

  content.split(/\r\n|\r|\n/).forEach((rawLine, index) => {
    const trimmed = rawLine.trim();
    if (trimmed === '') {
      return;
    }

    const parts = trimmed.split(';');
    if (parts.length !== 2) {
      errors.push({
        line: index + 1,
        raw: trimmed,
        message: 'Format invalide, "EAN;CodeProjet" attendu',
      });
      return;
    }

    const ean = parts[0].trim();
    const codeProjet = parts[1].trim();

    if (!EAN_FORMAT.test(ean)) {
      errors.push({
        line: index + 1,
        raw: trimmed,
        message: 'EAN invalide, 13 chiffres attendus',
      });
      return;
    }

    if (!CODE_PROJET_FORMAT.test(codeProjet)) {
      errors.push({
        line: index + 1,
        raw: trimmed,
        message: 'Code projet invalide (alphanumérique et "-" uniquement)',
      });
      return;
    }

    lines.push({ean, codeProjet});
  });

  return {lines, errors};
}
